import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '@core/models/octa.model';
import { AuthService } from '@core/services/auth.service';
import { DepartmentContextService } from '@core/services/department-context.service';
import { AppROUTES } from '@config/app.config';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'sra-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  loggedInUser!: IUser;
  isLoggedOut = false;

  constructor(
    public authService: AuthService,
    private readonly oauthService: OAuthService,
    private readonly router: Router,
    private readonly elementRef: ElementRef,
    private readonly departmentContext: DepartmentContextService,
  ) {}

  showMenu = false;
  hasMultipleDepartments = false;

  ngOnInit(): void {
    this.authService.loggedUser.subscribe((user: IUser) => {
      this.loggedInUser = user;
      this.isLoggedOut = !user.email;
    });

    this.departmentContext.department$.subscribe((departments: string[]) => {
      this.hasMultipleDepartments = departments.length > 1;
    });
  }

  /* On logo click, if user has multiple departments, show dropdown to switch account or logout. If user has only one department, directly logout. */
  onLogoClick(): void {
    if (this.hasMultipleDepartments) {
      this.toggleMenu();
    } else {
      this.logout();
    }
  }

  /* Toggle dropdown */
  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

  @HostListener('document:click', ['$event'])
  closeDropdownOnOutsideClick($event: MouseEvent): void {
    if (!this.showMenu) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains($event.target);

    if (!clickedInside) {
      this.showMenu = false;
    }
  }

  /* Logout user, clear department context and navigate to logout page */
logout(): void {
  this.authService.clearUser();
  this.departmentContext.reset();
  this.showMenu = false;
  this.oauthService.logOut(true);
  this.router.navigate([AppROUTES.LOGOUT]);
}

  /* Switch account (keep session, reset context) */
  switchAccount(): void {
    localStorage.removeItem('activeDepartment');
    localStorage.removeItem('departments');
    this.router.navigate(['/department']);
    this.showMenu = false;
  }
}
